<form [formGroup]="userForm()" *transloco="let t; prefix: 'registration.page.userForm'">
  <div class="form-container">
    <htx-alert
      variant="info"
      [title]="t('hint.label')"
      [message]="t('hint.text')"
      [closable]="true"
    ></htx-alert>

    <htx-button
      (click)="autoFill()"
      icon="autorenew">
      Auto Fill (Demo)
    </htx-button>

    <htx-form-section
      [title]="t('sections.personalInfo')"
      [icon]="'badge'"
      [formGroup]="userForm()"
      [showErrorSummary]="false"
      [fieldLabels]="userFormFieldLabels()"
    >
      <div class="grid-two-columns">
        <htx-dropdown-field-with-error
          [ctrl]="userForm().controls['salutation']"
          [label]="t('controls.salutation.label')"
          [options]="salutationOptions()"
          placeholder="Select salutation"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-dropdown-field-with-error>
        <htx-text-field-with-error
          [ctrl]="userForm().controls['firstName']"
          [label]="t('controls.firstName.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="userForm().controls['lastName']"
          [label]="t('controls.lastName.label')"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="userForm().controls['position']"
          [label]="t('controls.position.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </div>
    </htx-form-section>

    <htx-form-section
      [title]="t('sections.contactData')"
      [icon]="'contact_mail'"
      [formGroup]="userForm()"
      [showErrorSummary]="false"
      [fieldLabels]="userFormFieldLabels()"
    >
      <div class="grid-two-columns">
        <htx-text-field-with-error
          [ctrl]="userForm().controls['phoneNumber']"
          [label]="t('controls.phoneNumber.label')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="userForm().controls['email']"
          [label]="t('controls.email.label')"
          [placeholder]="'beispiel@firma.de'"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
        <htx-text-field-with-error
          [ctrl]="userForm().controls['emailConfirm']"
          [label]="t('controls.emailConfirm.label')"
          [placeholder]="'beispiel@firma.de'"
          [required]="true"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </div>
    </htx-form-section>


    <htx-form-section
      [title]="t('sections.confirmations')"
      [icon]="'verified_user'"
      [formGroup]="userForm()"
      [showErrorSummary]="false"
      [fieldLabels]="userFormFieldLabels()"
    >
      <htx-checkbox-field-with-error
        [ctrl]="userForm().controls['isRepresentative']"
        [label]="t('controls.isRepresentative.text')"
        [required]="true"
        [errorMessages]="{ required: '' }"
      >
      </htx-checkbox-field-with-error>
      <htx-checkbox-field-with-error
        [ctrl]="userForm().controls['hasAgreedToDataProtectionDeclaration']"
        [label]="t('controls.hasAgreedToDataProtectionDeclaration.text')"
        [required]="true"
        [errorMessages]="{ required: '' }"
      >
      </htx-checkbox-field-with-error>
    </htx-form-section>
  </div>
</form>
